var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "top-info no-gutters" }, [
    _c(
      "div",
      { staticClass: "orange-area cursor-pointer", on: { click: _vm.onClick } },
      [_c("span", [_vm._v("Crea il tuo viaggio")])]
    ),
    _vm._v(" "),
    _c("a", {
      staticClass: "logo-sx image-contain",
      attrs: { href: "https://www.qualitygroup.it/", target: "_blank" }
    }),
    _vm._v(" "),
    _vm.LOGO_EXTERNAL_1 !== undefined
      ? _c("a", {
          staticClass: "logo1 image-contain",
          attrs: {
            href: _vm.LOGO_EXTERNAL_1,
            target:
              _vm.LOGO_EXTERNAL_1 != "javascript:void(0);" ? "_blank" : "_self"
          }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.LOGO_EXTERNAL_3 !== undefined
      ? _c("a", {
          staticClass: "logo3 image-contain",
          attrs: {
            href: _vm.LOGO_EXTERNAL_3,
            target:
              _vm.LOGO_EXTERNAL_1 != "javascript:void(0);" ? "_blank" : "_self"
          }
        })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "text-logo text-uppercase" }, [
      _vm._v("Un progetto")
    ]),
    _vm._v(" "),
    _c("a", {
      staticClass: "logo-dx image-contain",
      attrs: { href: _vm.TOP_LINK_CHI_SIAMO_URL, target: "_blank" }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56852e04", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56852e04","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/mobile/pages/layout/home/InfoArea.vue
// module id = null
// module chunks = 